// 单纯调用api 就不计划引入amap-jsapi-loader
import Axios from 'axios'
import base from '@/utils/index'
const baseFunc = base()
const { getLocalStorage, setLocalStorage } = baseFunc

// 获取位置信息
export function getPositionInfo () {
  return new Promise((resolve, reject) => {
    let positionInfo = getLocalStorage('positionInfo')
    if (positionInfo) {
      resolve(JSON.parse(positionInfo))
      return
    }
    Axios.get('https://restapi.amap.com/v3/ip', {
      params: { key: 'f111dcad7fcd955939bf6c2d73737562' }
    }).then(res => {
      const { data = {} } = res
      if (data.status !== '1') {
        reject(new Error('查询失败'))
        return
      }
      positionInfo = {
        city: data.city,
        adcode: data.adcode,
        rectangle: data.rectangle
      }
      setLocalStorage('positionInfo', positionInfo)
      resolve(positionInfo)
    }).catch(() => {
      reject(new Error('查询失败'))
    })
  })
}

/**
 * 模糊搜索地点
 * @param {*} params // 查询参数 详见 https://lbs.amap.com/api/webservice/guide/api/search
 * @param {*} isPosition // 是否查询用户当前所在城市
 * @returns
 */
export function POI (params, isPosition = true) {
  return new Promise(async (resolve, reject) => {
    if (!params.keywords) {
      resolve([])
      return
    }
    let cityNmae = ''
    if (isPosition) {
      const { city } = await getPositionInfo()
      cityNmae = city
    }
    Axios.get('https://restapi.amap.com/v3/place/text', {
      params: {
        key: 'f111dcad7fcd955939bf6c2d73737562',
        citylimit: !!cityNmae,
        city: cityNmae,
        // types: '',
        ...params
      }
    }).then(res => {
      const { data = {} } = res
      if (data.status !== '1') return reject(new Error('查询失败'))
      resolve(data.pois)
    }).catch(() => {
      reject(new Error('查询失败'))
    })
  })
}

/**
 * 获取城市天气
 * @param {*} city // 城市名称、区域编码（如『上海市』、『310000』）不传默认用户所在城市
 */
export function getWeather (city = '') {
  return new Promise(async (resolve, reject) => {
    if (!city) {
      const { adcode } = await getPositionInfo()
      city = adcode
    }
    Axios.get('https://restapi.amap.com/v3/weather/weatherInfo', {
      params: {
        key: 'f111dcad7fcd955939bf6c2d73737562',
        extensions: 'base',
        city
      }
    }).then(res => {
      const { data = {} } = res
      if (data.status !== '1') {
        reject(new Error('查询失败'))
        return
      }
      let weather = {
        temperature: data?.lives?.[0].temperature,
        weather: data?.lives?.[0].weather,
        url: _getIcon(data?.lives?.[0].weather)
      }
      resolve(weather)
    }).catch(() => {
      reject(new Error('查询失败'))
    })
  })
}

// 精简高得返回的天气现象
const iconWeatherMap = {
  '风': ['有风', '平静', '微风', '和风', '清风', '强风/劲风', '疾风', '大风', '烈风', '风暴', '狂爆风', '飓风', '热带风暴', '龙卷风'],
  '多云': ['少云', '晴间多云', '多云'],
  '雪': ['雪', '阵雪', '小雪', '中雪', '大雪', '暴雪', '小雪-中雪', '中雪-大雪', '大雪-暴雪', '冷'],
  '雾': ['浮尘', '扬沙', '沙尘暴', '强沙尘暴', '雾', '浓雾', '强浓雾', '轻雾', '大雾', '特强浓雾'],
  '晴': ['晴', '热'],
  '雨夹雪': ['雨雪天气', '雨夹雪', '阵雨夹雪'],
  '雨': ['阵雨', '雷阵雨', '雷阵雨并伴有冰雹', '小雨', '中雨', '大雨', '暴雨', '大暴雨', '特大暴雨', '强阵雨', '强雷阵雨', '极端降雨', '毛毛雨/细雨', '雨', '小雨-中雨', '中雨-大雨', '大雨-暴雨', '暴雨-大暴雨', '大暴雨-特大暴雨', '冻雨'],
  '阴': ['阴', '霾', '中度霾', '重度霾', '严重霾', '未知']
}

/**
 * 根据天气现象返回其图标icon url
 * @param {String} weather 天气现象
 * @returns 天气现象对应的某一类的url
 */
 function _getIcon (weather) {
  // 这个是icon的默认值
  let url = require('@/assets/images/weather/阴.png')

  for (const weatherKey in iconWeatherMap) {
    if (Object.hasOwnProperty.call(iconWeatherMap, weatherKey)) {
      const weatherNames = iconWeatherMap[weatherKey]
      const findWeatherItem = weatherNames.find(name => weather === name)

      // 如果找了某一类的图标了，那重新复制url
      if (findWeatherItem) {
        // 这里的weatherKey和icon的名字一一对应了
        url = require(`@/assets/images/weather/${weatherKey}.png`)
        // console.debug('@find weather key = ', weatherKey)
        break
      }
    }
  }

  return url
}